"use client";

import { createContext, useContext, useState } from "react";

import { DebuggerMenu } from "./debugger-menu";
import { usePersist } from "./use-persist";

type Props = {
  children: React.ReactNode;
};

type DebuggerToggles = {
  scrollSpy: boolean;
  commission: boolean;
};

const defaultToggles: DebuggerToggles = {
  scrollSpy: false,
  commission: false,
};

const DebugContext = createContext<DebuggerToggles>(defaultToggles);

export function useDebugToggles() {
  return useContext(DebugContext);
}

export function VisualDebugger({ children }: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [toggles, setToggles] = useState<DebuggerToggles>(defaultToggles);
  const hasActiveDebug = Object.values(toggles).some(Boolean);

  const isEnabled = usePersist({
    storageKey: "visual-debugger",
    queryParamKey: "debug",
  });

  const handleToggleChange = (key: keyof DebuggerToggles) => {
    setToggles((current) => ({
      ...current,
      [key]: !current[key],
    }));
  };

  const handleDisableAll = () => {
    setToggles(defaultToggles);
  };

  return (
    <DebugContext value={toggles}>
      <div
        data-debug={toggles.scrollSpy}
        data-debug-active={hasActiveDebug}
      >
        {isEnabled ? (
          <DebuggerMenu
            isOpen={isMenuOpen}
            onOpenChange={setIsMenuOpen}
            toggles={toggles}
            onToggleChange={handleToggleChange}
            onDisableAll={handleDisableAll}
          />
        ) : null}
        {children}
      </div>
    </DebugContext>
  );
}
